/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tree_Type_170_TitleInputs */

const en_tree_type_170_title = /** @type {(inputs: Tree_Type_170_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matcha Cupcake`)
};

const ar_tree_type_170_title = /** @type {(inputs: Tree_Type_170_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`كب كيك الماتشا`)
};

const de_tree_type_170_title = /** @type {(inputs: Tree_Type_170_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matcha-Cupcake`)
};

const es_tree_type_170_title = /** @type {(inputs: Tree_Type_170_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cupcake de matcha`)
};

const fr_tree_type_170_title = /** @type {(inputs: Tree_Type_170_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cupcake au matcha`)
};

const it_tree_type_170_title = /** @type {(inputs: Tree_Type_170_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cupcake al matcha`)
};

const ja_tree_type_170_title = /** @type {(inputs: Tree_Type_170_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`抹茶カップケーキ`)
};

const ko_tree_type_170_title = /** @type {(inputs: Tree_Type_170_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`말차 컵케이크`)
};

const pt_br_tree_type_170_title = /** @type {(inputs: Tree_Type_170_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cupcake de Matcha`)
};

const ru_tree_type_170_title = /** @type {(inputs: Tree_Type_170_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Капкейк с матча`)
};

const th_tree_type_170_title = /** @type {(inputs: Tree_Type_170_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คัพเค้กมัทฉะ`)
};

const tr_tree_type_170_title = /** @type {(inputs: Tree_Type_170_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matchalı Cupcake`)
};

const zh_cn_tree_type_170_title = /** @type {(inputs: Tree_Type_170_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`抹茶纸杯蛋糕`)
};

const zh_tw_tree_type_170_title = /** @type {(inputs: Tree_Type_170_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`抹茶杯子蛋糕`)
};

/**
* | output |
* | --- |
* | "Matcha Cupcake" |
*
* @param {Tree_Type_170_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const tree_type_170_title = /** @type {((inputs?: Tree_Type_170_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tree_Type_170_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tree_type_170_title(inputs)
	if (locale === "ar") return ar_tree_type_170_title(inputs)
	if (locale === "de") return de_tree_type_170_title(inputs)
	if (locale === "es") return es_tree_type_170_title(inputs)
	if (locale === "fr") return fr_tree_type_170_title(inputs)
	if (locale === "it") return it_tree_type_170_title(inputs)
	if (locale === "ja") return ja_tree_type_170_title(inputs)
	if (locale === "ko") return ko_tree_type_170_title(inputs)
	if (locale === "pt_br") return pt_br_tree_type_170_title(inputs)
	if (locale === "ru") return ru_tree_type_170_title(inputs)
	if (locale === "th") return th_tree_type_170_title(inputs)
	if (locale === "tr") return tr_tree_type_170_title(inputs)
	if (locale === "zh_cn") return zh_cn_tree_type_170_title(inputs)
	return zh_tw_tree_type_170_title(inputs)
});